var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.messageText && _vm.alert.type==='error')?_c('v-alert',{class:`v-alert v-sheet theme--dark elevation-0 v-alert--dense ${_vm.alert.type}`,attrs:{"color":`${_vm.alert.color}`}},[_vm._v(_vm._s(_vm.messageText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }